<div id="play" class="button button-transparent player__overlay-pp" onclick="window.app && app.voyoVideo.playClick()">
    {{ svg "play-fill" 44 "icon icon_pause"}}{{ svg "pause-fill" 44 "icon icon_play"}}
</div>
